import {Alert, Button, Paper, TextField, Typography} from "@mui/material";
import {VideoDialogs} from "../utils/dialog";
import FileUpload from "../utils/upload";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CheckIcon from "@mui/icons-material/Check";
import * as React from "react";
import {createContext, useEffect, useRef, useState} from "react";
import {getVideoURL, post} from "../utils/post";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import {Locker} from "../utils/Locker";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";

import css from "../css/problem.module.css";

export const ProblemContext = createContext({});
const Incorrect = ({loadNextProblem}) => {
    return (
        <>
            <Alert severity="error">
                <Typography sx={{ml: 0.5}}>Неверно</Typography>
                <VideoDialogs>
                    <Locker>
                        <Button id={"showVideo"} size={"small"} variant={"text"}>
                            <span style={{borderBottom: "dotted"}}>
                                Посмотреть верное решение
                            </span>
                        </Button>
                    </Locker>
                </VideoDialogs>
                <FileUpload>
                    <Locker>
                        <Button id={"showErrors"} size={"small"} variant={"text"}>
                            <span style={{borderBottom: "dotted"}}>
                                Работа над ошибками по фото
                            </span>
                        </Button>
                    </Locker>
                </FileUpload>
            </Alert>
            <Button id={"nextProblem"}
                    endIcon={<ArrowForwardIosIcon/>}
                    onClick={loadNextProblem}
                    fullWidth={true}
                    sx={{mt: 1}}
                    variant={"contained"}
                    size={"large"}
            >
                Следующая задача
            </Button>
        </>
    )
}
const Correct = ({loadNextProblem}) => {
    return (
        <>
            <Alert icon={<CheckIcon fontSize="inherit"/>} severity="success">Верно</Alert>
            <Button id={"nextProblem"} endIcon={<ArrowForwardIosIcon/>} onClick={loadNextProblem} fullWidth={true}
                    sx={{mt: 1}}
                    variant={"contained"} size={"large"}>Следующая задача</Button>
        </>
    )
}
const Solving = ({id, hint, loadNextProblem}) => {
    const [answer, setAnswer] = useState("");
    const [isCorrect, setIsCorrect] = useState(false);
    const [isInCorrect, setIsInCorrect] = useState(false);

    const mainButtonRef = useRef(null);
    const secondaryButtonRef = useRef(null);

    const onSolving = async (e) => {
        e.preventDefault();

        const {isRight} = await post({method: "solved", id, answer}, true);

        if (isRight) {
            setIsCorrect(true);
        } else {
            setIsInCorrect(true);
        }

    }

    if (isCorrect) return <Correct loadNextProblem={loadNextProblem}/>
    if (isInCorrect) return <Incorrect loadNextProblem={loadNextProblem}/>


    return (
        <div className={"solving"}>
            <form onSubmit={onSolving} className={css.solving}>
                <TextField
                    size={"small"}
                    sx={{flex: 1}}
                    helperText={hint}
                    required
                    fullWidth
                    label="Ответ"
                    variant={"filled"}
                    value={answer}
                    onChange={e => setAnswer(e.target.value)}
                    autoComplete="off"
                    inputProps={{
                        autoCorrect: 'off',
                        autoCapitalize: 'off',
                        spellCheck: 'false',
                        //inputMode: "decimal",
                        //pattern: "-?[0-9]*[.,]?[0-9]*",
                        type: "text"
                    }}
                />
                <Button id={"checkAnswer"}
                        sx={{mt: "2px"}}
                        type={"submit"} size={"large"} variant="contained" startIcon={<ArrowUpwardIcon/>}
                        ref={mainButtonRef}>
                    Проверить
                </Button>
            </form>
            <Button id={"skipProblem"}
                    endIcon={<ArrowForwardIosIcon/>}
                    onClick={loadNextProblem}
                    sx={{mt: 1}} variant="text"
                    size="small"
                    ref={secondaryButtonRef}
            >
                Пропустить
            </Button>
        </div>
    )
}
const SolvedAll = () => {
    return (
        <div>
            <Typography variant={"h1"} align={"center"}>
                <WorkspacePremiumIcon sx={{fontSize: 90}}/>
            </Typography>
            <Typography variant={"h2"} align={"center"} gutterBottom>
                Поздравляем!
            </Typography>
            <Typography variant={"h4"} align={"center"} gutterBottom>
                Задачи закончились!
            </Typography>
            <Typography variant={"h5"} align={"center"} gutterBottom>
                Теперь ты точно сдашь экзамен на максимальный балл!
            </Typography>
        </div>
    )
}
export const Problem = () => {
    const [videoURL, setVideoURL] = useState(null);
    const [data, setData] = useState(null);
    const [solvedAll, setSolvedAll] = useState(false);
    const videoDownloading = useRef({});

    const loadNextProblem = () => {
        setData(null);
        setVideoURL(null);
        videoDownloading.controller?.abort();

        post({method: "problem"}, true).then(async ({data, info}) => {
            if (data) {

                if (data.solvedAll) {
                    return setSolvedAll(true)
                }

                setData(data);


                if (!info.locked) {
                    videoDownloading.controller = new AbortController();
                    getVideoURL(data.videoFileId, videoDownloading.controller.signal).then(setVideoURL).catch(() => {})
                }
            }
        });
    }

    useEffect(() => {
        loadNextProblem()
    }, []);

    if (solvedAll) return <SolvedAll/>

    return data && (
        <ProblemContext.Provider value={{videoURL, data}}>
            <div className={css.problem}>
                <Paper elevation={3} sx={{p: 2}}>
                    <Solving id={data.id} hint={data.hint} answer={data.answer} loadNextProblem={loadNextProblem}/>
                </Paper>
                <Paper elevation={3} sx={{p: 2}}>
                    <Typography variant="h5">
                        Задача #{data.qid}
                    </Typography>
                    <div dangerouslySetInnerHTML={{__html: data.HTMLBody}}/>
                </Paper>
            </div>
        </ProblemContext.Provider>
    )
}
